var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useEffect, useState } from 'react';
var initState = {
  screenX: NaN,
  screenY: NaN,
  clientX: NaN,
  clientY: NaN,
  pageX: NaN,
  pageY: NaN
};
export default (function () {
  var _a = __read(useState(initState), 2),
      state = _a[0],
      setState = _a[1];

  useEffect(function () {
    var moveHandler = function moveHandler(event) {
      var screenX = event.screenX,
          screenY = event.screenY,
          clientX = event.clientX,
          clientY = event.clientY,
          pageX = event.pageX,
          pageY = event.pageY;
      setState({
        screenX: screenX,
        screenY: screenY,
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      });
    };

    document.addEventListener('mousemove', moveHandler);
    return function () {
      document.removeEventListener('mousemove', moveHandler);
    };
  }, []);
  return state;
});